import React from 'react';
import { FiArrowDownLeft, FiArrowUpRight, FiClock } from 'react-icons/fi';

export const screenButtons = [
  { key: 'idle', label: '01 - IDLE' },
  { key: 'ringing', label: '02 - RINGING' },
  { key: 'oncall', label: '03 - ON CALL' },
  { key: 'conference', label: '04 - CONFERENCE' },
];

export const dialKeys = [
  ['1', ''],
  ['2', 'ABC'],
  ['3', 'DEF'],
  ['4', 'GHI'],
  ['5', 'JKL'],
  ['6', 'MNO'],
  ['7', 'PQRS'],
  ['8', 'TUV'],
  ['9', 'WXYZ'],
  ['*', ''],
  ['0', '+'],
  ['#', ''],
];

export const campaigns = [
  { color: 'var(--green)', name: 'Mortgage Refinance Q1', meta: 'Predictive - 847 leads', badge: 'LIVE', badgeClass: 'cb-active' },
  { color: 'var(--green)', name: 'Home Insurance Renewal', meta: 'Power - 1,203 leads', badge: 'LIVE', badgeClass: 'cb-active' },
  { color: 'var(--amber)', name: 'Credit Card Upsell', meta: 'Preview - 312 leads', badge: 'PAUSED', badgeClass: 'cb-paused' },
];

export const callLogs = [
  { icon: <FiArrowDownLeft />, color: 'var(--green)', name: 'Priya Mehta', num: '+91 98765 43210', dur: '6m 42s', time: '11:32 AM' },
  { icon: <FiArrowUpRight />, color: 'var(--blue)', name: 'Amit Kumar', num: '+91 91234 56789', dur: '2m 18s', time: '11:14 AM' },
  { icon: <FiArrowUpRight />, color: 'var(--red)', name: 'Unknown', num: '+91 80001 11223', dur: 'No answer', time: '10:58 AM', danger: true },
  { icon: <FiArrowDownLeft />, color: 'var(--green)', name: 'Sanjay Rao', num: '+91 99887 76655', dur: '9m 04s', time: '10:30 AM' },
  { icon: <FiArrowUpRight />, color: 'var(--blue)', name: 'Neha Singh', num: '+91 70011 22334', dur: '4m 51s', time: '10:11 AM' },
];

export const contacts = [
  { initials: 'PM', name: 'Priya Mehta', num: '+91 98765 43210', tone: 'blue' },
  { initials: 'AK', name: 'Amit Kumar', num: '+91 91234 56789', tone: 'violet' },
  { initials: 'SR', name: 'Sanjay Rao', num: '+91 99887 76655', tone: 'amber' },
  { initials: 'NS', name: 'Neha Singh', num: '+91 70011 22334', tone: 'green' },
];

export const callbacks = [
  { icon: <FiClock />, name: 'Rahul Joshi', due: 'Due: 1:00 PM - Home Insurance', color: 'var(--amber)' },
  { icon: <FiClock />, name: 'Divya Sharma', due: 'Due: 2:30 PM - Mortgage', color: 'var(--text-dim)' },
  { icon: <FiClock />, name: 'Arjun Nair', due: 'Due: 4:15 PM - Credit Card', color: 'var(--text-dim)' },
];

export const interactions = [
  { date: 'Mar 11, 2026 - 2:14 PM', duration: '6m 42s', outcome: 'Callback Requested', className: 'ho-cb', note: '"Wanted to review the loan tenure options. Asked about 20yr vs 25yr EMI breakup. Promised callback in 3 days."' },
  { date: 'Mar 07, 2026 - 11:00 AM', duration: '3m 18s', outcome: 'No Decision', className: 'ho-no', note: '"Busy - said to call during afternoon hours. Mild interest noted."' },
  { date: 'Feb 28, 2026 - 4:30 PM', duration: '9m 04s', outcome: 'Partial Commitment', className: 'ho-sale', note: '"Interested in refinancing at 8.45%. Processing fee waiver was key motivator. Agreed to receive documentation."' },
  { date: 'Feb 20, 2026 - 10:15 AM', duration: '2m 05s', outcome: 'Not Interested', className: 'ho-no', note: '"Rejected at first contact. Later warmed up during follow-up."' },
  { date: 'Feb 14, 2026 - 9:00 AM', duration: '1m 30s', outcome: 'First Contact', className: 'ho-no', note: '"Cold outreach. No interest at time. Voicemail left."' },
];

export const confParticipants = [
  { initials: 'PM', name: 'Priya Mehta', meta: '(Customer)', role: '+91 98765 43210 - Mortgage Refinance Q1', status: 'Speaking', statusClass: 'ps-active', duration: '00:12:08', tone: { background: 'var(--navy)', color: '#fff' }, speaking: true, controls: ['pause', 'volume', 'close'] },
  { initials: 'RK', name: 'Rohit Khanna', meta: '(RM - Internal)', role: 'Ext. 2214 - Relationship Manager', status: 'On Hold', statusClass: 'ps-hold', duration: '00:08:34', tone: { background: 'var(--amber-lt)', color: 'var(--amber)' }, hold: true, controls: ['play', 'volume', 'close'] },
  { initials: 'RV', name: 'Raj Verma', meta: '(You - Agent)', role: 'Ext. 1042 - Primary Agent', status: 'Active', statusClass: 'ps-you', duration: '00:12:08', tone: { background: 'var(--blue-lt)', color: 'var(--blue)' }, controls: ['pause', 'mic', 'leave'] },
];
